import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Form, Col, InputGroup } from 'react-bootstrap';
import { chatOff, controlFlowCX } from '../../actions';
import TimerClock from './timer';
import { detectIntentText } from './dialogEfect';

import { agentId } from '../../apis/stringConnection';
import moment from 'moment';
import { varChatBot, dataBaseManager, attributesChat } from '../hupUtils/utils';
import { renderMusic } from '../hupUtils/utilsChat';

let emoji = require('node-emoji');

class efect2 extends React.Component {

    state = {
        inputText: undefined,
        inputOpt: undefined,
        textAux: 'Completa la respuesta',
        arrayMessage: null,
        control: null
    }



    componentDidMount() {
        //inicia el bot
        this.varChat = [];
        this.flagControl = null;
        this.renderchatStart("hello");
    }


    btImputText(text, next, label, value, flagReturnFlow) {
        let emojified = emoji.emojify(label, this.onMissing());
        emojified = varChatBot(emojified, this.props.userUtil);
        return <div>

            <Row className='btIlnputTextChat'>
                <Col md={{ span: 4, offset: 4 }} xs={{ span: 10, offset: 1 }}>

                    <Form  >
                        <span>
                            <Form.Group controlId="ControlInput1">
                                <Form.Label className='label_color' column="lg" lg={6} xs={8}>{emojified}</Form.Label>
                                <Form.Control name="code"
                                    type="text" required value={this.state.inputText}
                                    onChange={(event) => { this.setState({ inputText: event.target.value }) }}
                                    onKeyPress={(e) => { this.renderkeyMessage(e, value) }} placeholder={text.placeHolder} />
                                <Form.Control.Feedback>{text.feedback}</Form.Control.Feedback>
                            </Form.Group>
                        </span>

                    </Form>

                </Col>
            </Row>

            {next ? this.btContinuar(flagReturnFlow ? this.returnFlow : value, flagReturnFlow, "text") : null}

        </div>

    }

    btOptionsShortCuts(shortCuts) {

        const opciones = Object.keys(shortCuts).map((key, index) => {
            return <span key={key}> <h5 href="#" onClick={() => { this.nextMessage(shortCuts[key].value, undefined, shortCuts[key].value) }} className="action-button animate purple" key={key} >{shortCuts[key].label}</h5></span>
        });
        return opciones;
    }

    btImputOptions(options, add, next, cases, label, value, valueAux) {
        let opt = null;
        let addOption = null;

        let emojified = emoji.emojify(label, this.onMissing());
        emojified = varChatBot(emojified, this.props.userUtil);

        if (options) {
            opt = Object.keys(options).map((key, index) => {
                if (key === 0)
                    return <option selected key={key} style='pruebaColor'>{options[key].label}</option>

                return <option key={key} value={options[key].id}>{options[key].label}</option>
            });
        }

        if (add) {
            addOption = <Row>
                <Col md={{ span: 2, offset: 5 }} xs={{ span: 5, offset: 2 }}>
                    <span>  <h5 href="#" onClick={(e) => {
                        this.flagValue = true;
                        this.nextMessage(valueAux)
                    }}
                        className="action-button animate purple btIlnputNextChat" key={2} >{add}</h5> </span>
                </Col>
            </Row>
        }


        return <div>
            <Row className='btIlnputTextChat'>
                <Col md={{ span: 4, offset: 4 }} xs={{ span: 10, offset: 1 }}>

                    <Form  >
                        <span>
                            <Form.Group controlId="ControlInputC1">
                                <Form.Label className='label_color' column="lg" lg={2}>{emojified}</Form.Label>
                                <Form.Control as="select"
                                    value={this.state.inputOpt}
                                    onChange={(e) => { this.setState({ inputOpt: e.target.value }); this.selectFunctions(cases, e.target.value); }}
                                >
                                    {opt}
                                </Form.Control>
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            </Form.Group>
                        </span>

                    </Form>

                </Col>
            </Row>

            {addOption}
            {next ? this.btContinuar(value, null, "options") : null}

        </div>
    }

    btContinuar(text, flagReturnFlow, value) {

        if (flagReturnFlow) {
            this.returnFlow = null;
        }
        return <Row>
            <Col md={{ span: 6, offset: 4 }} xs={{ span: 2, offset: 2 }}>
                <span>  <h5 href="#" onClick={(e) => { this.nextMessage(text, undefined, value) }} className="action-button animate purple btIlnputNextChat" key={2} >Continuar</h5> </span>
            </Col>
        </Row>
    }


    bttimeClock(next, value) {

        return (<div className='btFlushtimer'>
            <Row>
                <Col md={{ span: 3, offset: 4 }} xs={{ span: 6 }}>
                    <TimerClock programa={true}></TimerClock>
                </Col>
            </Row>
            {next ? this.btContinuar(value) : null}
        </div>);
    }

    renderPauseControl() {

        return (
            <div className="sp-container" id='content_Chat0' >
                <div className="sp-content" id='content_Chat1'>
                </div>
            </div>
        );
    }

    renderStartControl(control, Text, controlAux) {

        let emojified = emoji.emojify(Text, this.onMissing());
        emojified = varChatBot(emojified, this.props.userUtil);

        return (
            <div className="sp-container" id='content_Chat0' >
                <div className="sp-content" id='content_Chat1'>
                    <div className="sp-globe" id='content_Chat2'></div>
                    <h2 className="frame-1 h2-efect2 " id='content_Chat3' >{emojified}</h2>


                    <h2 className="frame-2 h2-efect2" id='content_Chat4'>
                        {control}
                        {controlAux}
                    </h2>


                </div>
            </div>

        );
    }

    nextMessage(text, event, value) {

        if (this.end) {
            this.props.chatOff();
            return;
        }
        if (event === undefined) {
            let value2Next = null;
            switch (value) {
                case "text":
                    if (this.addDialog) {
                        this.renderchatStart(this.state.inputText);
                    }
                    value2Next = this.state.inputText;
                    break;
                case "options":
                    value2Next = this.valorCases;
                    break;
                default:
                    value2Next = value;
                    break;

            }

            this.renderSaveValue(value2Next);
            this.flagControl = null;
            this.renderchatStart(text);
        }

    }

    selectFunctions(cases, obj) {

        this.valorCases = null;
        cases.map((item, i) => {
            if (item.label === obj)
                this.valorCases = item.value;
        });

    }


    renderkeyMessage = (event, value) => {
        if (event.key === "Enter" || event.key === "13") {
            event.preventDefault();
            this.nextMessage(value, undefined, "text");
        }
    }


    //dialogFlow
    async renderchatStart(text) {
        detectIntentText(text, this.props.token, this.props.sessionId, agentId).then((response) => {
            this.setState({ arrayMessage: response });
        });

    }


    onMissing(name) {
        return name;
    }


    renderCurrentControl() {

        this.timeout = setTimeout(() => {
            if (this.renderChat.length - 1 >= this.itemChat) {
                this.setState({ control: this.renderChat[this.itemChat] });
                this.itemChat++;
                if (this.renderChat.length - 1 >= this.itemChat)
                    this.renderCurrentControlPause();
            }

        }, 1000);
    }


    renderCurrentControlPause() {

        this.timeout = setTimeout(() => {
            this.setState({ control: this.renderPauseControl() });
            this.renderCurrentControl();
        }, 2000);
    }



    componentDatabase(tipo, path, objectIn, mensaje, mensajeError) {
        let men = dataBaseManager(tipo, path, objectIn, mensaje, mensajeError);
        if (men && men.mensaje)
            this.props.popupBot({ mensaje: men.mensaje });
        return men;
    }



    cleanVar() {
        this.query = null;
        this.level = null;
        this.save = null;
        this.param = null;
        this.create = null;
        this.valueas = null;
        this.saveas = null;
        this.attributes = null;
        this.addDialog = null;
        this.stateDialog = null;
        this.end = null;

    }


    queryObjectValidate(query) {
        query = varChatBot(query, this.props.userUtil);

        const starCountRef2 = this.componentDatabase('get', query);
        starCountRef2.on('value', (snapshot2) => {
            if (snapshot2.val()) {
                Object.keys(this.shortcut).map((item, i) => {
                    if (snapshot2.val().state === this.shortcut[item].termino) {
                        this.shortCutValue = this.shortcut[item].value;
                    }
                });

            }
        })

    }

    updateVarControl(item2) {

        if (item2.playMusic) {
            this.sessionOverMusic = renderMusic(this.music);
            this.sessionOverMusic.play();
        }
        if (item2.stopMusic)
            this.sessionOverMusic.stop();
        if (item2.move)
            this.props.controlFlowCX({ activate: "1", messageBoy: item2.messageBoy });

        if (item2.shortcut) {
            this.shortcut = item2.shortcut;
            this.flagValue = true;
            this.queryObjectValidate(item2.dataBase.query);
            this.ruteShortCut = item2.ruteShortCut;
        }

        if (item2.dataBase) {
            this.query = item2.dataBase.query;
            this.level = item2.dataBase.level;
            this.save = item2.dataBase.save;
            this.param = item2.dataBase.param;
            this.create = item2.dataBase.create;
            this.valueas = item2.dataBase.valueAs;
            this.saveas = item2.dataBase.saveAs;
            this.attributes = item2.dataBase.attributes;
        }
        else
            this.cleanVar();

        this.ruteShortCut = null;
        this.flagValue = undefined;
        this.addDialog = item2.addDialog;
        this.stateDialog = item2.stateDialog;
        this.end = item2.end;
    }

    renderCurrentControlPause2() {

        this.timeout = setTimeout(() => {
            // this.setState({ control: this.renderPauseControl() });
            this.rendershortCuts(this.shortCutValue);
            this.shortCutValue = null;
        }, 2000);
    }

    rendershortCuts(text) {
        this.shorCutText = text;
        this.timeout = setTimeout(() => {
            this.renderchatStart(this.shorCutText);
            this.flagControl = null;
            if (this.shortCutValue) {
                this.renderCurrentControlPause2();

            }
        }, 2500);
    }


    renderControlChat() {

        console.log(this.state.arrayMessage);
        if (this.state.arrayMessage !== null && this.state.arrayMessage !== undefined && this.state.arrayMessage.responseMessages !== null) {

            this.renderParamsDialogFlow();
            this.setState({ control: this.renderPauseControl() });
            this.flagControl = true;
            this.itemChat = 0;

            this.renderChat = this.state.arrayMessage.responseMessages.map((item, i) => {

                if (item.text) {
                    return this.renderStartControl(<div></div>, item.text.text[0]);
                }
                else {
                    let item2 = item.payload;
                    this.updateVarControl(item2);

                    if (this.ruteShortCut && this.shortCutValue)
                        this.rendershortCuts(this.ruteShortCut);
                    if (item2.messageBot)
                        this.props.popupBot({ mensaje: item2.messageBot, sleep: 30000 });

                    switch (item2.typeControl) {
                        case 'options':
                            let options = item2.options;
                            if (item2.options.query)
                                options = this.renderOptionsQuery(item2.options.query, item2.options.criteria, item2.options.value, item2.options.label);
                            if (item2.returnOrigin) {
                                this.returnFlow = item2.value;
                                this.queryOrigin = item2.dataBase.query;
                                this.paramOrigin = item2.dataBase.param;
                            }

                            return this.renderStartControl(this.btImputOptions(options, item2.add, true, options, item2.label, item2.value, item2.valueAux), item2.text);
                        case 'shortCuts':
                            return this.renderStartControl(this.btOptionsShortCuts(item2.options), item2.text);
                        case 'text':
                            this.state.inputText = undefined;
                            return this.renderStartControl(this.btImputText(item2.textControl, true, item2.label, item2.value, item2.flagReturnFlow), item2.text);
                        case 'time':
                            this.time = item2.time;
                            this.acumtime = item2.acumtime;
                            return this.renderStartControl(this.bttimeClock(true, item2.value), item2.text);
                        case 'text_time':
                            this.time = item2.time;
                            this.acumtime = item2.acumtime;
                            return this.renderStartControl(this.bttimeClock(false, null), item2.text, this.btImputText(item2.textControl, true, item2.label, item2.value, item2.flagReturnFlow));
                        default:
                            return this.renderStartControl(<div></div>, item.text.text);

                    }

                }
            })

            this.renderCurrentControl();
        }
        this.renderParamsDialogFlow();

    }

    renderParamsDialogFlow() {
        if (this.state.arrayMessage !== null && this.state.arrayMessage !== undefined && this.state.arrayMessage.parameters !== undefined && this.query !== null) {
            let valuesSub = attributesChat(this.state.arrayMessage.parameters);
            let query = this.query + '/' + this.level;
            this.componentDatabase('update', query, {
                ...valuesSub
            });

        }
    }
    renderOptionsQuery(query, criteria, value, label) {

        query = varChatBot(query, this.props.userUtil);
        if (query !== null && criteria !== null) {
            let options = [];
            options.push({ value: "0", label: "Selecciona tu objetivo" })
            const starCountRef3 = this.componentDatabase('get', query);
            starCountRef3.on('value', (snapshot) => {
                let objectQuery = snapshot.val();

                if (objectQuery) {
                    Object.keys(objectQuery).map((key, index) => {
                        let objectQueryCurrent = objectQuery[key];


                        let flagCriteria = true;
                        let countCriteria = 0;

                        for (const keyCriteria in criteria) {

                            if (criteria[keyCriteria].type) {
                                switch (criteria[keyCriteria].type) {
                                    case ">":
                                        if (objectQueryCurrent[keyCriteria] <= criteria[keyCriteria].value)
                                            flagCriteria = false;
                                        break;

                                    case ">=":
                                        if (objectQueryCurrent[keyCriteria] < criteria[keyCriteria].value)
                                            flagCriteria = false;
                                        break;

                                    case "<":
                                        if (objectQueryCurrent[keyCriteria] >= criteria[keyCriteria].value)
                                            flagCriteria = false;
                                        break;

                                    case "<=":
                                        if (objectQueryCurrent[keyCriteria] > criteria[keyCriteria].value)
                                            flagCriteria = false;
                                        break;

                                    case "<>":
                                        if (objectQueryCurrent[keyCriteria] < criteria[keyCriteria].value[0] || objectQueryCurrent[keyCriteria] > criteria[keyCriteria].value[1])
                                            flagCriteria = false;
                                        break;

                                    case "!=":
                                        if (objectQueryCurrent[keyCriteria] !== criteria[keyCriteria].value)
                                            flagCriteria = false;
                                        break;

                                    case "optional":
                                        if (!criteria[keyCriteria].value.includes(objectQueryCurrent[keyCriteria]))
                                            flagCriteria = false;
                                        break;

                                }

                            }
                            else {
                                if (criteria[keyCriteria] !== objectQueryCurrent[keyCriteria])
                                    flagCriteria = false;
                            }
                        }
                        if (flagCriteria && objectQueryCurrent.concepto)
                            options.push({ value: value === 'key' ? key : objectQueryCurrent[value], label: objectQueryCurrent[label] });
                    });

                }

            });
            return options;
        }
    }

    renderSaveValue(value) {

        if (this.save && value !== null && this.flagValue === undefined) {
            let values = [];
            this.query = varChatBot(this.query, this.props.userUtil);
            this.query = this.query.replace("@" + this.saveas, this.varChat[this.saveas]);
            let valuesSub = attributesChat(this.attributes);

            if (this.level) {
                valuesSub[this.param] = value;
                valuesSub = this.renderTimeSave(valuesSub);
                values[this.level] = { ...valuesSub };
            }
            else if (this.create) {

                let key = this.componentDatabase('key', this.query);
                valuesSub[this.param] = value;
                valuesSub = this.renderTimeSave(valuesSub);
                values[key] = { ...valuesSub };
                if (this.saveas)
                    this.varChat[this.saveas] = this.valueas ? key : valuesSub[this.param];
            }
            else {
                values = valuesSub;
                values = this.renderTimeSave(values);
                values[this.param] = value;
            }

            if (this.stateDialog) {
                this.componentDatabase('update', varChatBot(this.stateDialog.query, this.props.userUtil), {
                    state: this.stateDialog.state
                });
            }
            if (this.queryOrigin && this.saveas) {
                let values2Origin = [];
                values2Origin[this.paramOrigin] = this.varChat[this.saveas];
                this.componentDatabase('update', varChatBot(this.queryOrigin, this.props.userUtil), {
                    ...values2Origin
                });
                this.queryOrigin = null;
                this.paramOrigin = null;
            }




            this.componentDatabase('update', this.query, {
                ...values
            });
        }

    }

    renderTimeSave(values) {
        if (this.time) {
            values["time"] = this.props.onMessageChat;
            values["date"] = moment().format("MMM Do YY")

        }
        if (this.acumtime) {
            this.acumtime = this.time + this.acumtime + 180;
            values["timeStart"] = moment().add('seconds', this.acumtime).format('h:mm:ss a');
            values["timeEnd"] = moment().add('seconds', this.acumtime).add('seconds', this.props.onMessageChat).format('h:mm:ss a');
        }

        return values;
    }

    render() {


        if (this.flagControl === null)
            this.renderControlChat();

        if (this.state.control !== null)
            return this.state.control;
        else
            return <div></div>;
    }
};

const mapAppStateToProps = (state) => (
    {
        userUtil: state.mainReducer.userUtil,
        onMessageChat: state.mainReducer.onMessageChat,

    });


export default connect(mapAppStateToProps, { chatOff, controlFlowCX })(efect2);